import React from "react";
// import { AllVendorLeads } from "../../../FetchAPI";
import Sidebar from "../../Sidebar";
import DeshbordBreadcrumb from "../../Breadcrumb/DeshbordBreadcrumb";
import LeadAssignDataTable from "./LeadAssignDataTable";
import DeshBoardFooter from "../../DeshBoardFooter";
import { Helmet } from "react-helmet";
import { useAuth } from "../../../../Store/AuthContext";

export default function LeadAssignView() {
  const { RendomTokenfetch } = useAuth();
  // const [VendorLeads] = AllVendorLeads(RendomTokenfetch, "5", "0");

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb page1={[{ name: "My Leads" }]} />

        <section className="user-dashboard">
          <div className="dashboard-outer">

            {RendomTokenfetch && <LeadAssignDataTable />}
            {/* <div className="row">
              <div className="col-lg-12">
                <div className="ls-widget">
                  <div className="tabs-box">
                    {RendomTokenfetch && (
                      <LeadAssignDataTable VendorLeads={VendorLeads} />
                    )}
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </section>
        <div className="deshboard_footer">
          <DeshBoardFooter />
        </div>
      </div>
    </>
  );
}
